import { createCustomEnum } from "./../customEnum";

const ZendeskTicketReasons = createCustomEnum({
	AmvIncrease: {
		value: 33,
		name: "amv_increase",
		displayName: "AMV Increase",
	},
	ApplicationSoftPend: {
		value: 66,
		name: "application_soft_pend",
		displayName: "Application Soft Pend",
	},
	MccUpdate: {
		value: 32,
		name: "mcc_update",
		displayName: "MCC Update",
	},
	MonthlyBillingRequest: {
		value: 35,
		name: "monthly_billing_request",
		displayName: "Monthly Billing Request",
	},
	NdfRequest: {
		value: 34,
		name: "ndf_request",
		displayName: "NDF Request",
	},
	TicketIncreaseRequest: {
		value: 31,
		name: "ticket_increase_request",
		displayName: "Ticket Increase Request",
	},
	RetentionOther: {
		value: 1,
		name: "other",
		displayName: "Other",
	},
});

export default ZendeskTicketReasons;
